import {
  CollapsiblePageCardProps,
  FormFilterChipsProps,
  PageCard,
  PageCardSection,
} from "@techsharegov/react-ui";

export type CollapsibleFormFiltersPageCardProps = CollapsiblePageCardProps & {
  filterChipsProps?: FormFilterChipsProps;
};

export const LocalCollapsibleFormFiltersPageCard: React.FC<
  CollapsibleFormFiltersPageCardProps
> = ({
  children,
  collapsibleRightButtons,
  filterChipsProps,
  ...collapsiblePageCardProps
}) => {
  return (
    <PageCard>
      <PageCardSection title="Search Parameters">{children}</PageCardSection>
    </PageCard>
  );
};
